module.exports = __webpack_public_path__ + "img/pic_coin_bigsale1@2x.6db96128.png";